// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__7k8Aw","spinning":"loading_spinning__oifC4","spinnerD3wgkg":"loading_spinnerD3wgkg__EbvO2"};